var MediaSizes;
(function (MediaSizes) {
    MediaSizes[MediaSizes["XXS_MAX"] = 575] = "XXS_MAX";
    MediaSizes[MediaSizes["XS"] = 576] = "XS";
    MediaSizes[MediaSizes["XS_MAX"] = 767] = "XS_MAX";
    MediaSizes[MediaSizes["SM"] = 768] = "SM";
    MediaSizes[MediaSizes["SM_MAX"] = 991] = "SM_MAX";
    MediaSizes[MediaSizes["MD"] = 992] = "MD";
    MediaSizes[MediaSizes["MD_MAX"] = 1199] = "MD_MAX";
    MediaSizes[MediaSizes["LG"] = 1200] = "LG";
    MediaSizes[MediaSizes["LG_MAX"] = 1599] = "LG_MAX";
    MediaSizes[MediaSizes["XL"] = 1600] = "XL";
})(MediaSizes || (MediaSizes = {}));
export default MediaSizes;
